import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { createCards, showCards, editCards } from '~/config/routes';
import List from './List';
import New from './New';
import Edit from './Edit';
import Show from './Show';
import { CardsProvider } from './context';
import Can from '~/contexts/Can';
import NotPermissionPage from '~/pages/NotPermissionPage';

function Cards() {
  return (
    <CardsProvider>
      <Switch>
        <Route
          exact
          path={createCards.spec}
          render={(props) => (
            <>
              <Can I="new" a="Cards">
                {() => <New {...props} />}
              </Can>
              <Can not I="new" a="Cards">
                {() => <NotPermissionPage />}
              </Can>
            </>
          )}
        />
        <Route
          exact
          path={editCards.spec}
          render={(props) => (
            <>
              <Can I="edit" a="Cards">
                {() => <Edit {...props} />}
              </Can>
              <Can not I="edit" a="Cards">
                {() => <NotPermissionPage />}
              </Can>
            </>
          )}
        />
        <Route
          exact
          path={showCards.spec}
          render={(props) => (
            <>
              <Can I="show" a="Cards">
                {() => <Show {...props} />}
              </Can>
              <Can not I="show" a="Cards">
                {() => <NotPermissionPage />}
              </Can>
            </>
          )}
        />
        <Route
          render={(props) => (
            <>
              <Can I="list" a="Cards">
                {() => <List {...props} />}
              </Can>
              <Can not I="list" a="Cards">
                {() => <NotPermissionPage />}
              </Can>
            </>
          )}
        />
      </Switch>
    </CardsProvider>
  );
}

export default Cards;
